import { useEffect, useMemo, useState } from "react";

import { Log } from "../models/Log";
import { deleteLog, getLogs, GetLogsPayload } from "../services/logServices";
import { useApiProvider } from "../providers/api/apiProvider";

export const useLogController = () => {
  const {
    paginatedApiCall,
    simpleApiCall,
  } = useApiProvider();

  const [ page, setPage ] = useState<number>( 1 );
  const [ perPage, setPerPage ] = useState<number>( 15 );
  const [ total, setTotal ] = useState<number>( 0 );

  const [ logs, setLogs ] = useState<Array<Log>>([]);
  const [ loadingLogs, setLoadingLogs ] = useState<boolean>( false );

  const changePage = ( page: number ) => setPage( page );

  const loadLogs = async () => {
    const response = await paginatedApiCall<GetLogsPayload, Log>( getLogs, { page, perPage }, () => setLoadingLogs(( value ) => !value ));

    if( response !== null ) {
      setPage( response.page );
      setTotal( response.total );
      setPerPage( response.perPage );

      setLogs( response.results );
    }
  };

  const handleDelete = async ( id: string ) => await simpleApiCall<string, boolean>( deleteLog, id );

  useEffect(() => {
    loadLogs();
    // eslint-disable-next-line
  }, [ page, perPage ]);

  return useMemo(() => ({
    page,
    perPage,
    total,
    logs,
    loadingLogs,
    changePage,
    handleDelete,
    // eslint-disable-next-line
  }), [
    page,
    perPage,
    total,
    logs,
    loadingLogs,
  ]);
};
